import { useEffect, useState } from "react";
import { useRouteError } from "react-router";
import posthog from "posthog-js";
import { StyleRoot } from "@ttc3k/trekker";
import { ErrorBoundaryPage } from "shared/components/root";
import {
  isStaleAssetError,
  reloadForStaleBuild,
} from "shared/utils/staleBuildReload";
import styles from "styled-system/styles.css?inline";

/**
 * React Router `errorElement` for every top-level route. It replaces the
 * route's own element, so under `/app` none of Root's providers (Auth0,
 * Apollo, StyleRoot) are mounted: keep dependencies to the bare minimum and
 * leave Auth0 "reset and sign out" off.
 */
export function RouteErrorElement() {
  const error = useRouteError();
  const isStaleAsset = isStaleAssetError(error);
  const [isReloading, setIsReloading] = useState(isStaleAsset);

  useEffect(() => {
    if (isStaleAsset && reloadForStaleBuild()) {
      // Never leave a blank page if the reload is cancelled or blocked.
      const fallback = setTimeout(() => setIsReloading(false), 4000);
      return () => clearTimeout(fallback);
    }
    setIsReloading(false);
    console.error("[RouteErrorElement]", error);
    try {
      if (posthog.__loaded) {
        posthog.captureException(
          error instanceof Error ? error : new Error(String(error)),
          {
            errorBoundary: "RouteErrorElement",
            fileName: "RouteErrorElement.tsx",
            path: window.location.pathname,
          },
        );
      }
    } catch {
      // PostHog may not be initialized
    }
  }, [error, isStaleAsset]);

  if (isReloading) {
    return null;
  }

  return (
    <StyleRoot styles={[styles]}>
      <ErrorBoundaryPage showResetAndSignOut={false} />
    </StyleRoot>
  );
}
